import React from 'react';
import HrnbContainer, { HrnbRow, HrnbCol } from '../components/controls/HrnbContainer';
import HrnbCard from '../components/controls/HrnbCard';
import HrnbAlert from '../components/controls/HrnbAlert';
import NewsCard from '../components/news/NewsCard';
import '../css/pages/NewsPage.css';

/**
 * Страница новостей
 * Пока заглушка - в будущем интеграция с API новостей
 */
export default function NewsPage() {
    // Заглушка - статический список новостей
    const newsItems = [
        {
            id: 1,
            title: 'Добро пожаловать на платформу!',
            date: '2025-01-10',
            preview: 'Мы рады приветствовать всех новых пользователей на нашей платформе...',
            image: '/news/default-news.jpg',
            content: 'Полный текст новости...'
        },
        {
            id: 2,
            title: 'Обновление системы баттлов',
            date: '2025-01-08',
            preview: 'Добавлены новые функции для проведения баттлов...',
            image: '/news/default-news.jpg',
            content: 'Полный текст новости...'
        },
        {
            id: 3,
            title: 'Новые правила платформы',
            date: '2025-01-05',
            preview: 'Ознакомьтесь с обновлёнными правилами использования...',
            image: '/news/default-news.jpg',
            content: 'Полный текст новости...'
        }
    ];

    return (
        <HrnbContainer className="news-page">
            <HrnbRow>
                <HrnbCol xs={12}>
                    <HrnbCard title="Новости" subtitle="Последние обновления и события">
                        <p className="news-page__intro">
                            Здесь вы найдёте все важные новости и обновления платформы.
                        </p>
                    </HrnbCard>
                </HrnbCol>
            </HrnbRow>

            <HrnbRow>
                <HrnbCol xs={12}>
                    {newsItems.length === 0 ? (
                        <HrnbAlert variant="info">
                            Новостей пока нет. Следите за обновлениями!
                        </HrnbAlert>
                    ) : (
                        <div className="news-page__list">
                            {newsItems.map((news) => (
                                <NewsCard key={news.id} news={news} />
                            ))}
                        </div>
                    )}
                </HrnbCol>
            </HrnbRow>
        </HrnbContainer>
    );
}
